class UpdateBilling {
  // Updates to /membership-account/membership-billing/
  constructor() {
    this.init();
  }

  init() {
    const submitButton = document.querySelector('#pmpro_btn-submit');
    if (submitButton) {
      submitButton.addEventListener('click', (e) => {
        // Toggle the button state
        submitButton.classList.toggle('sending');
        submitButton.value = 'Update';

        setTimeout(() => {
          this.checkAndScrollToError(submitButton);
        }, 100); // Delay to allow for potential DOM updates
      });
    }
  }

  checkAndScrollToError(submitButton) {
    const messageElement = document.querySelector('#pmpro_message');
    if (
      messageElement &&
      messageElement.style.display !== 'none' &&
      messageElement.classList.contains('pmpro_error')
    ) {
      messageElement.scrollIntoView({ behavior: 'smooth' });
      // Reset the button state if no error is present
      submitButton.classList.remove('sending');
      submitButton.value = 'Update';
    } else {
    }
  }
}

export default UpdateBilling;
